/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostAnomalyByCloudRequest extends models.CommonCostRequest {
    getFixupPrototypeFunction() { return CostAnomalyByCloudRequest.fixupPrototype; }

    static newInstance(model: Partial<CostAnomalyByCloudRequest>): CostAnomalyByCloudRequest {
        let obj = Object.assign(new CostAnomalyByCloudRequest(), model);
        CostAnomalyByCloudRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostAnomalyByCloudRequest>): CostAnomalyByCloudRequest {
        if (!model) return null;
        return CostAnomalyByCloudRequest.newInstance(<CostAnomalyByCloudRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostAnomalyByCloudRequest) {
        if (!obj) return;

        models.CostAnomalyByCloudRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostAnomalyByCloudRequest): boolean {
        if (models.CommonCostRequest.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostAnomalyByCloudRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Granularity to aggregate data
     */
    granularity: models.TrendGranularity;

}
